import { render } from "./ContactUsview.vue?vue&type=template&id=34cdb9b3&scoped=true"
import script from "./ContactUsview.vue?vue&type=script&lang=js"
export * from "./ContactUsview.vue?vue&type=script&lang=js"

import "./ContactUsview.vue?vue&type=style&index=0&id=34cdb9b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34cdb9b3"]])

export default __exports__